import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/extraPayments';

import { cancelDraft } from './utils';

export default function* listenResetDraft() {
  yield takeEvery(actions.cancelDraft.type, cancelDraft);
}
